import { ORDER_BY } from 'components/table/constants';

const COLUMNS_LIST = {
  USER_NAME: {
    value: 'userName',
    label: 'general.name',
    defaultOrderBy: ORDER_BY.ASC,
    sortName: 'userName',
    order: 1
  },
  LAST_ACCESS: {
    value: 'lastAccess',
    label: 'general.last_access',
    sortName: 'userLastAccess',
    order: 2
  },
  STATUS: { value: 'status', label: 'general.access', order: 3 },
  REASON: { value: 'reason', label: 'general.reasons', order: 4 },
  ENGAGEMENT: {
    value: 'engagement',
    label: 'general.engagement',
    order: 5,
    sortName: 'engagement'
  },
  FIRST_ACCESS: {
    value: 'firstAccess',
    label: 'general.first_access',
    sortName: 'userFirstAccess',
    order: 6
  },
  PROGRESS: {
    value: 'progress',
    label: 'general.progress',
    sortName: 'progress.completedPercentage',
    order: 7
  },
  PURCHASE_DATE: {
    value: 'purchaseDate',
    label: 'general.purchase_date',
    sortName: 'userPurchaseDate',
    order: 8
  },
  ACCESS_COUNT: {
    value: 'accessCount',
    label: 'general.access_count',
    sortName: 'userAccessCount',
    order: 9
  }
};

const DEFAULT_COLUMNS = [
  COLUMNS_LIST.LAST_ACCESS.value,
  COLUMNS_LIST.STATUS.value,
  COLUMNS_LIST.REASON.value,
  COLUMNS_LIST.PROGRESS.value,
  COLUMNS_LIST.ENGAGEMENT.value
];

const COLUMNS_LIMIT = 4;

const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  BLOCKED_BY_OWNER: 'BLOCKED_BY_OWNER',
  BLOCKED_BY_OWNER_V2: 'BLOCKED_BY_OWNER_V2',
  CHANGED_BY_OWNER: 'CHANGED_BY_OWNER',
  OVERDUE: 'OVERDUE'
};

const USER_PLUS_ACCESS = {
  DEPENDENT: 'DEPENDENT',
  HOLDER_WITHOUT_DEPENDENTS: 'HOLDER_WITHOUT_DEPENDENTS',
  HOLDER_WITH_DEPENDENTS: 'HOLDER_WITH_DEPENDENTS',
  WITHOUT_PLUS_ACCESS: 'WITHOUT_PLUS_ACCESS'
};

const categoryOptions = 'users_manager.deep_search.access.category_options';

const USER_TYPE = {
  BUYER: `${categoryOptions}.buyer`,
  FREE: `general.free`,
  GUEST: `${categoryOptions}.guest`,
  IMPORTED: `${categoryOptions}.imported`
};

const historyTypes = 'users_manager.users_detail.history_types';

const HISTORY_KEYS = {
  ADD_COMMENT: 'ADD_COMMENT',
  QUIZ_COMPLETION: 'QUIZ_COMPLETION',
  USER_AREA_COMPLETION: 'USER_AREA_COMPLETION',
  ACCESS_PAGE: 'ACCESS_PAGE',
  ACCESS_CLUB: 'ACCESS_CLUB'
};

const QUIZ_TYPES = {
  PROFILE: 'PROFILE',
  EXERCISE: 'EXERCISE'
};

const HISTORY_TYPES = {
  [HISTORY_KEYS.ADD_COMMENT]: {
    TITLE: `${historyTypes}.add_comment.title`,
    EMPTY_MSG: `${historyTypes}.add_comment.empty`,
    DESCRIPTION: `${historyTypes}.add_comment.description`
  },
  [HISTORY_KEYS.QUIZ_COMPLETION]: {
    TITLE: `${historyTypes}.quiz_completion.title`,
    EMPTY_MSG: `${historyTypes}.quiz_completion.empty`,
    [QUIZ_TYPES.PROFILE]: {
      DESCRIPTION: `${historyTypes}.quiz_completion.description.profile`
    },
    [QUIZ_TYPES.EXERCISE]: {
      DESCRIPTION: `${historyTypes}.quiz_completion.description.exercise`
    }
  },
  [HISTORY_KEYS.USER_AREA_COMPLETION]: {
    TITLE: `${historyTypes}.user_area_completion.title`,
    EMPTY_MSG: `${historyTypes}.user_area_completion.empty`,
    DESCRIPTION: `${historyTypes}.user_area_completion.description`
  },
  [HISTORY_KEYS.ACCESS_PAGE]: {
    TITLE: `${historyTypes}.access_page.title`,
    EMPTY_MSG: `${historyTypes}.access_page.empty`,
    DESCRIPTION: `${historyTypes}.access_page.description`
  },
  [HISTORY_KEYS.ACCESS_CLUB]: {
    TITLE: `${historyTypes}.access_club.title`,
    EMPTY_MSG: `${historyTypes}.access_club.empty`,
    DESCRIPTION: `${historyTypes}.access_club.description`
  }
};

const USER_ROLES_LABEL = {
  ADMINISTRATOR: 'users_import.roles.administrator',
  CONTENT_EDITOR: 'users_import.roles.content_editor',
  STUDENT: 'users_import.roles.student',
  FREE_STUDENT: 'users_import.roles.free_student',
  MODERATOR: 'users_import.roles.moderator'
};

const ACTIONS = {
  BLOCK: 'BLOCK',
  UNBLOCK: 'UNBLOCK',
  DELETE: 'DELETE',
  RETRY: 'RETRY'
};

const ENGAGEMENT_LEVELS = ['none', 'low', 'medium', 'high', 'higher'];
const ENGAGEMENT_LABELS_PATH =
  'users_manager.deep_search.user.engagement_labels';
const ENGAGEMENT_LABELS = ENGAGEMENT_LEVELS.map(
  (level) => `${ENGAGEMENT_LABELS_PATH}.${level}`
);

const BIG_NUMBERS_PREFIX = 'users_manager.big_numbers';
const BIG_NUMBERS = {
  AREA_TOTAL_USERS: {
    type: 'areaTotalUsers',
    title: `${BIG_NUMBERS_PREFIX}.area_total_users.title`,
    description: `${BIG_NUMBERS_PREFIX}.area_total_users.description`
  },
  CONCLUSION_AVG: {
    type: 'conclusionPercentage',
    title: `${BIG_NUMBERS_PREFIX}.conclusion_avg.title`,
    description: `${BIG_NUMBERS_PREFIX}.conclusion_avg.description`
  },
  PROGRESS_AVG: {
    type: 'avgProgress',
    title: 'general.progress',
    description: `${BIG_NUMBERS_PREFIX}.user_average`
  },
  ENGAGEMENT_AVG: {
    type: 'avgEngagement',
    title: 'general.engagement',
    description: `${BIG_NUMBERS_PREFIX}.user_average`
  }
};

const IMPORT_TYPES = {
  IMPORT_MANUALLY: 'users_import.tabs.manually',
  IMPORT_FROM_CSV_FILE: 'users_import.tabs.in_batch',
  IMPORT_FROM_MARKETPLACE: 'users_import.tabs.from_hotmart',
  INVITE: 'users_manager.deep_search.access.category_options.guest'
};

const SMALLEST_VISIBLE_PERCENT = 0.1;

const PIRACY_COLUMNS_LIST = [
  'date',
  'ip',
  'device',
  'operational_system',
  'region'
];

const MAX_INFORMATION_LENGTH = 20;

const DESKTOP_DEVICE_LABEL = 'Desktop';

const KNOWN_ERROS = {
  RESEND_ACCESS_ABOVE_LIMIT: {
    label: 'mass_actions_erro_resend_above_limit',
    errorCode: '5355'
  },
  INVALID_ACTIONS: '9002'
};

const REASONS_BLOCK = {
  INAPPROPRIATE_BEHAVIOR: 'INAPPROPRIATE_BEHAVIOR',
  END_ACCESS_PERIOD: 'END_ACCESS_PERIOD',
  LATE_PAYMENT: 'LATE_PAYMENT',
  OTHERS: 'OTHERS',
  PIRACY_ATTEMPT: 'PIRACY_ATTEMPT',
  EXPIRED_ACCESS_TIME: 'EXPIRED_ACCESS_TIME'
};

export {
  ACTIONS,
  BIG_NUMBERS,
  COLUMNS_LIMIT,
  COLUMNS_LIST,
  DEFAULT_COLUMNS,
  DESKTOP_DEVICE_LABEL,
  ENGAGEMENT_LABELS,
  ENGAGEMENT_LEVELS,
  HISTORY_KEYS,
  HISTORY_TYPES,
  IMPORT_TYPES,
  KNOWN_ERROS,
  MAX_INFORMATION_LENGTH,
  PIRACY_COLUMNS_LIST,
  QUIZ_TYPES,
  SMALLEST_VISIBLE_PERCENT,
  USER_PLUS_ACCESS,
  USER_ROLES_LABEL,
  USER_STATUS,
  USER_TYPE,
  REASONS_BLOCK
};
